import axios from "axios";

const token = JSON.parse(localStorage.getItem('LS_ACCESS_TOKEN'))
export default axios.create({
    baseURL:'https://api.cronyproductions.co.ke',
    // baseURL:'https://crony-api.up.railway.app',
    // baseURL:'http://127.0.0.1:8000',

})